import { render, staticRenderFns } from "./new-templates.vue?vue&type=template&id=e93b7dc8"
import script from "./new-templates.vue?vue&type=script&lang=js"
export * from "./new-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports